export default {"src":"/_next/static/media/Infertility.7eb67c6a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};